import {useEffect, useState} from "react";
const axios = require('axios').default;

const baseUrl = '/m/api';

const objectToParams = (obj) => {
  return Object.keys(obj).map(key => key + '=' + encodeURIComponent(obj[key])).join('&');
}

const callWebshopAPI = (url, method, params, formEncoded) => {
    return new Promise( (resolve, reject) => {
        if (url[0] != "/") {
            url = `${baseUrl}/${url}`
        }
        if (!method) {
            method = 'GET'
        }
        if (!params) {
            params = [];
        }

        const init = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == 'POST' && params) {
            init.body = method == 'POST' && formEncoded ? objectToParams(params) : JSON.stringify(params)
        }

        fetch(url, init)
            .then(r => {
                console.log('Result', r);
                r.json()
                    .then(json => {
                        if (r.status == 401 || r.status == 403 || json.error) {
                            reject({
                                code: r.status,
                                message: json.error || r.message
                            })
                        }
                        else {
                            console.log('JSON', json);
                            resolve(json);
                        }
                    })
            })
            .catch(error => {
                console.log('Error', error);
                reject({
                    code: -1,
                    message: error
                })
            })
    })
}

const useWebshopApi = (url, method, params, formEncoded) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);



  console.log('Fetching url', url);

  useEffect( () => {
      setLoading(true);

      callWebshopAPI(url, method, params, formEncoded)
          .then((data) => {
              setData(data)
          })
          .catch (err => {
              setError(err)
          })
          .finally(() => {
              setLoading(false)
          })

    }, [])

  return {loading, error, data};
}

const useLoginApi = (username, password) => {
  return useWebshopApi('/ajax/login.php', 'POST', {username, password}, true);
}

const useShoppingCartApi = () => {
  return useWebshopApi('webshop/cart')
}

const getUserInfo = () => {
  return GETRequest('/user/me')
}

const uploadImageType = (image, type, progressCallback) => {
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('images[]', image);

        const params = {
            handleuploads: true,
            interface: 'HTML',
            redirect: '/',
            uploadtype: type,
            json: true,
            thumbnails: 640
        };

        const queryString = objectToParams(params);

        axios.request( {
            method: "post",
            url: '/system/iframes/upload_internal.php?' + queryString,
            data: formData,
            onUploadProgress: progressCallback
        }).then (
            data => resolve(data.data)
        ).catch(
            error => reject(error)
        );
    } )
}

const uploadImage = (image, progressCallback) => {
    return uploadImageType(image, 'printsorder', progressCallback)
};


export {
  uploadImage,
  uploadImageType,
  useLoginApi,
  useShoppingCartApi,
  callWebshopAPI
}